"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.MeControl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _AppPanel = require("@uifabric/portal-ux/lib/AppPanel");

var _Panel = require("@fluentui/react/lib/components/Panel");

var _Persona = require("@fluentui/react/lib/components/Persona");

var _Link = require("@fluentui/react/lib/Link");

var React = _interopRequireWildcard(require("react"));

var optionsStyles = require('../../Options/OptionsPane/Options.scoped.scss');
/**
 * Represents a simple me control
 */


var MeControl = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(MeControl, _React$Component);

  var _super = (0, _createSuper2.default)(MeControl);

  function MeControl() {
    (0, _classCallCheck2.default)(this, MeControl);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(MeControl, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          t = _this$props.t,
          isMeOpen = _this$props.isMeOpen,
          hideMe = _this$props.hideMe,
          logOut = _this$props.logOut,
          givenName = _this$props.givenName,
          familyName = _this$props.familyName,
          userName = _this$props.userName,
          userImageUrl = _this$props.userImageUrl,
          accountUrl = _this$props.accountUrl;
      var userFullName = t('{{givenName}} {{familyName}}', {
        givenName: givenName,
        familyName: familyName
      });
      var headerText = t('My Account');
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_AppPanel.AppPanel, {
        isOpen: isMeOpen,
        type: _Panel.PanelType.smallFixedFar,
        onDismiss: hideMe,
        headerText: headerText,
        closeButtonAriaLabel: t('CloseDialog', {
          dialogName: headerText
        }),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: optionsStyles.section,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Persona.Persona, {
            imageUrl: userImageUrl,
            imageAlt: userFullName,
            text: userFullName,
            secondaryText: userName
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: optionsStyles.section,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.Link, {
            href: accountUrl,
            target: "_blank",
            children: t('View my account')
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: optionsStyles.section,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.Link, {
            onClick: logOut,
            children: t('Sign out')
          })
        })]
      });
    }
  }]);
  return MeControl;
}(React.Component);

exports.MeControl = MeControl;